import { DefaultApi } from '../autogenerated/spdApiClient/apis/DefaultApi';
import {
  CreateUpdateInvoiceIssuerDto,
  CreateUpdateInvoiceIssuerDtoFromJSON,
  GetInvoiceIssuerDto,
  GetInvoiceIssuerOptionDto,
} from '../autogenerated/spdApiClient';
import { GridRecord } from '../../components/Grid/GridDataTypes';
import { invoiceIssuerForGrid } from '../../../spd/components/InvoiceIssuer/InvoiceIssuerSearch';
import { validateAgainst } from '../validation/validateAgainst';
import { InvoiceIssuerSchema } from '../validation/schemas';

export interface InvoiceIssuerContextInterface {
  get: (id: string) => Promise<GetInvoiceIssuerDto>;
  getAllCount: (filterText?: string) => Promise<number>;
  getAllByPortion: (
    pageSize: number,
    pageNumber: number,
    orderBy?: string,
    orderDirection?: string,
    filterText?: string,
  ) => Promise<GridRecord[]>;
  create: (dto: CreateUpdateInvoiceIssuerDto) => Promise<GetInvoiceIssuerDto>;
  update: (id: string, dto: CreateUpdateInvoiceIssuerDto) => Promise<void>;
  getAllActive: () => Promise<GetInvoiceIssuerOptionDto[]>;
}

export const InvoiceIssuerContext = (api: DefaultApi) => {
  return {
    get: async (id: string) => {
      return await api.invoiceIssuerControllerGet(id);
    },

    getAllByPortion: async (
      pageSize: number,
      pageNumber: number,
      orderBy?: string,
      orderDirection?: string,
      filterText?: string,
    ) => {
      const data = await api.invoiceIssuerControllerGetAllByPortion(
        pageSize,
        pageNumber,
        orderBy || '',
        orderDirection || '',
        filterText || '',
      );
      return data.map(invoiceIssuerForGrid);
    },

    getAllCount: (filterText?: string) =>
      api.invoiceIssuerControllerGetAllCount(filterText || ''),

    create: (dto: CreateUpdateInvoiceIssuerDto) =>
      api.invoiceIssuerControllerCreate(dto),

    update: (id: string, dto: CreateUpdateInvoiceIssuerDto) =>
      api.invoiceIssuerControllerUpdate(id, dto),

    getAllActive: () => api.invoiceIssuerControllerGetAllActive(),
  };
};

export const validate = (dto: CreateUpdateInvoiceIssuerDto) => {
  return validateAgainst(InvoiceIssuerSchema, dto);
};

export const invoiceIssuerData = (
  issuer?: GetInvoiceIssuerDto,
): CreateUpdateInvoiceIssuerDto => {
  return CreateUpdateInvoiceIssuerDtoFromJSON({
    active: true,
    ...issuer,
  });
};
